import axios from 'axios'

async function get_stat(data,setFetching,token,setData){
try{

setFetching(true)
const URL =`${process.env.REACT_APP_SERVER_AUTH_URL}get-statistics/`

const handleStat = await axios.post(URL,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        setFetching(false)
        console.log(err)
    })

    if (handleStat?.status == 200 && handleStat?.data?.success) {
        setData(handleStat?.data?.data)
    }
    setFetching(false)
}catch(err){
    setFetching(false)
    console.log(err)
}
}

export default get_stat